export const ORG_ID = "https://www.limen-ar.fr/#organization";
export const SITE_URL = "https://www.limen-ar.fr";

export const SERVICES = {
  "plaquiste-seine-et-marne": {
    slug: "plaquiste-seine-et-marne",
    breadcrumb: "Plaquiste 77",
    title: "Plaquiste en Seine-et-Marne : cloisons et doublages — LIMEN",
    meta: "Création de cloisons, doublages et ouvrages en plaques de plâtre en Seine-et-Marne. LIMEN étudie vos volumes et détaille les travaux dans votre devis.",
    h1: "Plaquisterie, cloisons et doublages en Seine-et-Marne",
    intro: "Créer une pièce, redistribuer un logement ou habiller un mur demande de choisir un ouvrage adapté à son usage. LIMEN vous accompagne dans la réalisation de cloisons et de doublages en plaques de plâtre, pour les particuliers comme pour les professionnels.",
    image: "/images/cloison-ossature-metallique-chantier.png",
    imageAlt: "Cloison placo sur ossature métallique en cours de montage — plaquiste en Seine-et-Marne",
    imageCaption: "Cloison sur ossature — chantier en cours",
    sections: [
      {
        heading: "Des cloisons adaptées à votre projet",
        paragraphs: [
          "Une cloison ne se résume pas à deux plaques et une ossature. Sa composition se choisit selon l'usage de la pièce : confort acoustique entre deux chambres, charges à supporter, pièce humide, passage de réseaux.",
          "Nous réalisons des cloisons sur ossature métallique, avec ou sans isolant, en adaptant la composition à votre projet — plaques hydrofuges et renforts lorsque la pièce l'exige.",
        ],
        bullets: [
          "Cloisons sur ossature métallique, avec ou sans isolant",
          "Composition choisie selon l'usage : acoustique, charges, humidité",
          "Plaques hydrofuges et renforts lorsque nécessaire",
          "Réseaux, ouvertures et renforts anticipés avant fermeture de l'ouvrage",
        ],
      },
      {
        heading: "Doublages, bandes et finitions",
        paragraphs: [
          "Le doublage permet de reprendre un mur existant et d'intégrer une isolation lorsque le projet le demande. Bandes, angles et niveau de préparation conditionnent directement la qualité visible de la finition.",
          "Votre devis détaille séparément les bandes, les angles, le niveau de préparation des surfaces et la peinture, afin que chaque poste soit lisible avant l'ouverture du chantier.",
        ],
      },
      {
        heading: "Ce qui détermine le devis",
        paragraphs: [
          "Le chiffrage dépend des surfaces, des hauteurs sous plafond, de l'accès au chantier, de la composition des ouvrages, des ouvertures à créer et de l'état des supports.",
          "Pour préparer un premier échange précis, vous pouvez joindre vos plans et photos directement dans le formulaire de demande d'étude.",
        ],
      },
    ],
    faq: [
      {
        q: "Peut-on isoler une cloison ?",
        a: "Oui, selon sa composition et l'objectif recherché. C'est la performance de l'ouvrage complet qui compte : nous étudions la composition adaptée lors de la visite technique.",
      },
      {
        q: "La peinture est-elle comprise ?",
        a: "Seulement si elle est mentionnée au devis. Les postes sont détaillés séparément pour que vous sachiez exactement ce qui est inclus.",
      },
      {
        q: "Intervenez-vous dans un logement occupé ?",
        a: "Oui. L'organisation du chantier et la protection des espaces sont étudiées ensemble lors de la visite, pour limiter la gêne au quotidien.",
      },
    ],
  },

  "isolation-interieure-seine-et-marne": {
    slug: "isolation-interieure-seine-et-marne",
    breadcrumb: "Isolation intérieure 77",
    title: "Isolation intérieure en Seine-et-Marne — LIMEN",
    meta: "Isolation intérieure des murs, plafonds et rampants en Seine-et-Marne. LIMEN étudie les supports, les épaisseurs et les finitions de votre projet.",
    h1: "Isolation intérieure des murs et plafonds en Seine-et-Marne",
    intro: "L'isolation intérieure se prépare en tenant compte du bâtiment existant, de son usage et de l'espace disponible. LIMEN réalise des doublages isolants ainsi que des ouvrages isolés sous plafonds ou rampants, selon les contraintes du projet.",
    image: "/images/doublage-isolant-mise-en-oeuvre.png",
    imageAlt: "Doublage isolant en mise en œuvre — isolation intérieure en Seine-et-Marne",
    imageCaption: "Doublage isolant — mise en œuvre",
    sections: [
      {
        heading: "Choisir une solution cohérente avec le bâtiment",
        paragraphs: [
          "Avant de recouvrir un mur ou un plafond, les supports et les traces d'humidité sont analysés : une isolation posée sur un support dégradé déplace le problème au lieu de le résoudre.",
          "Thermique et acoustique sont deux objectifs distincts, qui ne se traitent pas avec les mêmes compositions. Les interfaces avec les menuiseries et les réseaux sont étudiées en amont pour éviter les reprises.",
          "Nous n'annonçons aucune économie d'énergie chiffrée sans étude : les gains dépendent du bâtiment, de la solution retenue et de sa mise en œuvre.",
        ],
      },
      {
        heading: "Anticiper les conséquences sur l'aménagement",
        paragraphs: [
          "Isoler de l'intérieur modifie la pièce : épaisseur perdue, tableaux de fenêtre à reprendre, plinthes et équipements à adapter. Ces points sont identifiés avant le chiffrage, pas pendant le chantier.",
          "La visite technique permet de relever ces contraintes et de définir une solution réaliste, détaillée ensuite dans un devis poste par poste.",
        ],
      },
    ],
    faq: [
      {
        q: "Quelle épaisseur d'isolant prévoir ?",
        a: "Elle dépend de la solution choisie, de l'objectif visé et de la place disponible. La réponse se donne après étude de votre configuration, pas de manière générique.",
      },
      {
        q: "Peut-on traiter le bruit et le froid en même temps ?",
        a: "C'est possible selon la composition de l'ouvrage, mais les performances thermique et acoustique s'apprécient séparément. Nous définissons les deux objectifs avec vous avant de proposer une composition.",
      },
      {
        q: "Puis-je bénéficier d'aides financières ?",
        a: "Nous ne promettons aucune éligibilité. Les dispositifs d'aides, leurs critères et les qualifications exigées évoluent : ils sont à vérifier avant tout engagement.",
      },
    ],
  },

  "faux-plafonds-seine-et-marne": {
    slug: "faux-plafonds-seine-et-marne",
    breadcrumb: "Faux plafonds 77",
    title: "Faux plafonds et corniches LED en Seine-et-Marne — LIMEN",
    meta: "Faux plafonds en plaques de plâtre, retombées et corniches LED en Seine-et-Marne. LIMEN prépare les hauteurs, les réseaux et les finitions avec vous.",
    h1: "Faux plafonds et corniches LED en Seine-et-Marne",
    intro: "Un faux plafond permet de redéfinir un volume, de recevoir une isolation ou d'intégrer certains équipements. LIMEN réalise des plafonds en plaques de plâtre, des retombées et des corniches décoratives selon le dessin et les contraintes de votre intérieur.",
    image: "/images/faux-plafond-chantier-en-cours-77.png",
    imageAlt: "Faux plafond en cours de réalisation avec ossature métallique et suspentes — Seine-et-Marne",
    imageCaption: "Faux plafond — chantier en cours",
    sections: [
      {
        heading: "Préparer les hauteurs et les réservations",
        paragraphs: [
          "Un plafond suspendu se dessine d'abord sur le support : nature de la fixation, hauteur disponible, réseaux à conserver accessibles pour la maintenance. Ces éléments déterminent le système constructif.",
          "Parements et isolation éventuelle sont définis selon le projet, et les joints et angles sont traités selon ce qui est prévu au devis.",
        ],
      },
      {
        heading: "Dessiner un éclairage indirect",
        paragraphs: [
          "Corniches et retombées permettent d'intégrer un éclairage indirect, à condition de prévoir la place des équipements et leurs accès dès le dessin.",
          "Le devis distingue clairement les ouvrages, les luminaires, les alimentations et les raccordements. Lorsque le projet le demande, nous coordonnons l'intervention avec votre électricien.",
        ],
      },
    ],
    faq: [
      {
        q: "Combien de hauteur perd-on avec un faux plafond ?",
        a: "Cela dépend du système retenu et des équipements à intégrer : il n'existe pas de cote universelle. La hauteur exacte est déterminée à l'étude, en fonction de votre plafond existant.",
      },
      {
        q: "Les LED sont-elles comprises dans le devis ?",
        a: "Seuls les postes précisés au devis sont inclus. Ouvrages, luminaires et raccordements sont des postes distincts, détaillés avant l'ouverture du chantier.",
      },
      {
        q: "Comment accéder aux réseaux après la pose ?",
        a: "Des trappes ou des accès sont prévus aux endroits définis à l'étude, de manière à maintenir les réseaux accessibles pour la maintenance.",
      },
    ],
  },

  "amenagement-interieur-seine-et-marne": {
    slug: "amenagement-interieur-seine-et-marne",
    breadcrumb: "Aménagement intérieur 77",
    title: "Aménagement intérieur sur mesure en Seine-et-Marne — LIMEN",
    meta: "Niches, habillages TV et ouvrages décoratifs en plaques de plâtre en Seine-et-Marne. LIMEN étudie vos usages, vos dimensions et vos finitions.",
    h1: "Aménagement intérieur et habillages sur mesure",
    intro: "Une niche, un habillage TV ou une retombée de plafond doit s'intégrer à la pièce et à son usage quotidien. LIMEN réalise des ouvrages en plaques de plâtre pour organiser les volumes et soigner les détails de votre intérieur.",
    image: "/images/amenagement-tv-niche-led-sur-mesure.png",
    imageAlt: "Aménagement TV sur mesure avec niche et corniche LED — Seine-et-Marne",
    imageCaption: "Aménagement TV — réalisation sur mesure",
    sections: [
      {
        heading: "Partir de vos usages",
        paragraphs: [
          "Un ouvrage sur mesure réussi commence par vos usages : dimensions des équipements et des objets à intégrer, passage des câbles, accès pour la maintenance, ventilation, renforts nécessaires.",
          "Ces contraintes sont relevées avant la réalisation, pour que l'ouvrage serve durablement votre quotidien au lieu de le contraindre.",
        ],
      },
      {
        heading: "Coordonner le dessin et l'exécution",
        paragraphs: [
          "Niches, habillages TV, corniches : les dimensions et les finitions sont précisées au devis, de manière à aligner le dessin attendu et l'ouvrage réalisé.",
          "L'électricité et la peinture sont traitées en postes séparés, avec une coordination claire entre les intervenants lorsque le projet en comporte plusieurs.",
        ],
      },
    ],
    faq: [
      {
        q: "Puis-je envoyer une photo d'inspiration ?",
        a: "Oui. Joignez-la au formulaire avec les dimensions et des photos de la pièce : c'est la meilleure base pour étudier la faisabilité et préparer le chiffrage.",
      },
      {
        q: "Un habillage peut-il supporter une fixation TV ?",
        a: "Les charges et les renforts sont étudiés avant la réalisation. Signalez-nous les équipements à fixer dès la demande d'étude.",
      },
      {
        q: "Réalisez-vous la décoration complète de la pièce ?",
        a: "Nous réalisons uniquement les prestations définies au devis. Si votre projet dépasse notre périmètre, nous vous le signalons avant tout engagement.",
      },
    ],
  },

  "architectes-maitres-oeuvre": {
    slug: "architectes-maitres-oeuvre",
    breadcrumb: "Architectes & maîtres d'œuvre",
    title: "Plâtrerie et isolation pour architectes et maîtres d'œuvre — LIMEN",
    meta: "LIMEN accompagne architectes et maîtres d'œuvre pour leurs travaux de plâtrerie, d'isolation et de faux plafonds. Présentez votre dossier de consultation.",
    h1: "Un partenaire d'exécution pour vos projets intérieurs",
    intro: "Vous recherchez une entreprise pour exécuter vos ouvrages de plâtrerie, d'isolation ou de faux plafonds ? LIMEN étudie vos dossiers et les contraintes du chantier pour préparer une intervention structurée.",
    image: "/images/renovation-interieure-piece-a-vivre.png",
    imageAlt: "Intérieur rénové livré — exécution de plâtrerie et isolation pour architectes et maîtres d'œuvre",
    imageCaption: "Rénovation intérieure — ouvrage terminé",
    ctaLabel: "Transmettre un dossier de consultation",
    sections: [
      {
        heading: "Une étude fondée sur votre dossier",
        paragraphs: [
          "Plans, coupes, descriptifs, finitions attendues, calendrier : plus le dossier est précis, plus le chiffrage est juste. Nous étudions vos pièces écrites et signalons les points qui méritent une décision avant chiffrage.",
          "Compositions d'ouvrages, renforts, réservations et interfaces avec les autres lots sont précisés dans notre offre, pour limiter les avenants et les surprises en cours de chantier.",
        ],
      },
      {
        heading: "Une organisation partagée",
        paragraphs: [
          "Approvisionnements, coordination avec les autres corps d'état et suivi des points sensibles sont organisés avec votre équipe de maîtrise d'œuvre.",
          "Tout changement de périmètre est formalisé avant réalisation. La localisation du chantier et son volume sont étudiés dès le premier échange : transmettez votre dossier via le formulaire, plans et descriptifs joints.",
        ],
      },
    ],
    faq: [],
  },
};

export const SERVICE_LINKS = [
  { slug: "plaquiste-seine-et-marne", label: "Plaquisterie, cloisons & doublages" },
  { slug: "isolation-interieure-seine-et-marne", label: "Isolation intérieure" },
  { slug: "faux-plafonds-seine-et-marne", label: "Faux plafonds & corniches LED" },
  { slug: "amenagement-interieur-seine-et-marne", label: "Aménagement intérieur sur mesure" },
  { slug: "architectes-maitres-oeuvre", label: "Architectes & maîtres d'œuvre" },
];

export const buildBreadcrumbLd = (page) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Accueil", item: `${SITE_URL}/` },
    { "@type": "ListItem", position: 2, name: page.breadcrumb, item: `${SITE_URL}/${page.slug}` },
  ],
});

export const buildServiceLd = (page) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": `${SITE_URL}/${page.slug}#service`,
  name: page.h1,
  description: page.meta,
  provider: { "@id": ORG_ID },
  areaServed: "Seine-et-Marne",
});

export const buildFaqLd = (page) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: page.faq.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const pageJsonLd = (page) => {
  const list = [buildBreadcrumbLd(page), buildServiceLd(page)];
  if (page.faq.length > 0) list.push(buildFaqLd(page));
  return list;
};

export const LEGAL_SEO = {
  "mentions-legales": {
    title: "Mentions légales — LIMEN Aménagement & Rénovation",
    description: "Mentions légales du site limen-ar.fr, édité par LIMEN Aménagement & Rénovation : éditeur, hébergement et propriété intellectuelle.",
    path: "/mentions-legales",
  },
  "politique-de-confidentialite": {
    title: "Politique de confidentialité — LIMEN Aménagement & Rénovation",
    description: "Politique de confidentialité de LIMEN : données collectées via le formulaire de demande d'étude, finalités, conservation et droits RGPD.",
    path: "/politique-de-confidentialite",
  },
};
